<template>

    <div>
      <product-detail-component v-if="showProduct" :product="selectedProduct" :goBack="goBackFromProduct" />
      <section class="products" :class="{ hide: showProduct }" >
          <div class="container-fluid">
              <div class="search-container">
                <div class="search-wrapper">
                  <input
                    type="text"
                    class="search-input"
                    v-model="productSearch"
                    placeholder="Buscar productos..."
                    aria-label="Buscar productos"
                  >
                  <button class="search-button" type="button">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>

              <div class="box-title">
                  <h1>{{category.name}}</h1>
                  <ul class="subcategorias" >
                      <li v-if="(childrens.length>1)">
                          <router-link :to="{name:'Category', params: {id: category.id}}">
                            Todos
                          </router-link>
                      </li>

                      <li v-for="child in childrens">
                          <router-link :to="{name:'SubCategory', params: {id: category.id, sub: child.id }}" :class="{'active':(defaultCategory===child.category_id)}">
                            {{child.name}}
                          </router-link>
                      </li>
                  </ul>
              </div>

              <div class="row"  v-if="defaultCategory">
                <template v-if="!isLoading || products.length > 0">
                  <div class="col-lg-3 col-sm-6 col-xs-12" v-for="product in products" :key="product.COD_ARTICU" v-if="products.length>0">
                    <product-box :product="product" :onProductClick="onProductClick"></product-box>
                  </div>
                </template>
                <template v-if="isLoading">
                  <div class="col-lg-3 col-sm-6 col-xs-12" v-for="n in 8" :key="n">
                    <div class="product-skeleton">
                      <div class="skeleton-image"></div>
                      <div class="skeleton-content">
                        <div class="skeleton-title"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-price"></div>
                      </div>
                    </div>
                  </div>
                </template>


                <infinite-loading ref="infiniteLoading"  :identifier="infiniteId" @infinite="infiniteScrollRest" spinner="waveDots">

                  <div slot="no-more">
                    <h2></h2>
                  </div>
                  <div slot="no-results">
                    <div class="no-results-container">
                      <div class="no-results-icon">
                        <i class="fas fa-search"></i>
                      </div>
                      <h3>No se encontraron productos</h3>
                      <p>No encontramos productos que coincidan con tu búsqueda "{{ productSearch }}"</p>
                      <div class="suggestions">
                        <p>Sugerencias:</p>
                        <ul>
                          <li>Verifica que las palabras estén escritas correctamente</li>
                          <li>Intenta con términos más generales</li>
                          <li>Prueba con otras categorías</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </infinite-loading>


              </div>

          </div>
      </section>
    </div>
</template>

<script>
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

    import ProductBox from "@/components/ProductBox";
    import Api from '@/Api'
    import axios from 'axios'
    import {baseUrl} from "../Api";
    import ProductDetailComponent from './ProductDetailComponent.vue';

    export default {
        name: "CategoryPage",
        components: {ProductBox, ProductDetailComponent},
        data () {
            return {
                masterCategory:null,
                category:{},
                infiniteId: +new Date(),
                childrens:[],
                products: [],
                defaultCategory:null,
                categoryId: 0,
                currentPage:1,
                totalPage:0,
                productSearch:'',
                cancelToken:undefined,
                showProduct:false,
                selectedProduct:null,
                actualOffset:0,
                isLoading: false,
                debouncedHandleSearch: null, // robust debounce
            }
        },
        watch:{
          productSearch: function() {
            this.debouncedHandleSearch();
          }
        },

      created() {
        this.debouncedHandleSearch = debounce(this.handleSearch, 300);
      },
        methods:{
          handleSearch() {
            // Cancel any ongoing request
            if (this.cancelToken) {
              this.cancelToken.cancel("Operation canceled due to new search.");
            }
            this.products = [];
            this.currentPage = 1;
            this.lastSearch = this.productSearch;
            this.searchRequestId += 1;
            // Change infiniteId to force re-mount
            this.infiniteId++;
            this.$nextTick(() => {
              this.$refs.infiniteLoading.stateChanger.complete();

              if (this.$refs.infiniteLoading) {
                this.$refs.infiniteLoading.stateChanger.reset();
                this.infiniteScrollRest(this.$refs.infiniteLoading.stateChanger);
              }
            });
          },
              goBackFromProduct(){
                this.showProduct = false;
                this.$nextTick(() => {
                  window.scrollTo(0,this.actualOffset);
                });

              },
              onProductClick(product){
                this.actualOffset = window.pageYOffset;
                this.showProduct = true;
                this.selectedProduct = product;
                window.scrollTo(0,0);
              },
          changeCategory(category){


            this.products = [];
            this.currentPage = 1;
            this.defaultCategory = category;

            //console.log(this.$refs);
            this.$refs.infiniteLoading.stateChanger.reset();


            //this.infiniteScrollRest();

          },
          infiniteScrollRest ($state) {
            this.isLoading = true;
            let master = 0;
            if (!this.defaultCategory)
              return;

            if (this.masterCategory === this.defaultCategory)
              master=1;

           if (typeof this.cancelToken != typeof undefined) {
              this.cancelToken.cancel("Operation canceled due to new request.")
            }
            this.cancelToken = axios.CancelToken.source()

            Api().get('products?master='+master+'&search='+this.productSearch+'&sort_by=COD_ARTICU&category='+this.defaultCategory+'&per_page=10&page='+this.currentPage,{ cancelToken: this.cancelToken.token }).then(data=>{
                this.isLoading = false;

                if (data.data.data.data.length === 0 && this.currentPage === 1) {
                  $state.complete();
                  $state.noResults();
                  return;
                }

                data.data.data.data.forEach(value => {
                  this.products.push(value);
                });

                $state.loaded();

              if (parseInt(data.data.data.last_page)>0) {
                if ((this.currentPage)===(parseInt(data.data.data.last_page))){
                  $state.complete();
                }else{
                  this.currentPage = this.currentPage + 1;

                  if (!data.data.data.next_page_url)
                  {
                    $state.complete();
                  }
                }
              }else{
                $state.complete();
              }
            }).catch(err=>{
              this.isLoading = false;
              $state.complete();
            });
          },
        },
        mounted(){
            $('body').removeClass();
            this.categoryId = this.$route.params.id;
            //this.defaultCategory = this.$route.params.id;



             Api().get('category?parent='+this.categoryId).then(data=>{
                this.category = data.data.data.category;

                this.masterCategory = this.category.category_id;
                this.childrens = data.data.data.childrens;

                if(this.$route.params.sub)
                {
                  var subc =  this.$route.params.sub;

                  var subx = this.childrens.filter( c=>{
                    return (c.id==subc)
                  });
                  console.log(subc,subx);

                  this.defaultCategory  = subx[0].category_id;

                }else{
                  this.defaultCategory = this.category.category_id;
                }

                this.categoryId = this.defaultCategory;


            }).catch(err=>{

            });
        }
    }
</script>

<style scoped>
  .active {
    font-weight: bold !important;
  }

  .search-container {
    margin-bottom: 2em;
    display: flex;
    justify-content: center;
  }

  .search-wrapper {
    max-width: 400px;
    width: 100%;
    display: flex;
    position: relative;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    border-radius: 4px;
  }

  .search-input {
    flex: 1;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    padding: 1rem 1.5rem;
    font-size: 1.2rem;
    transition: border-color 0.15s ease-in-out;
    border-right: none;
    height: 56px;
  }

  .search-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
  }

  .search-button {
    border-radius: 0 4px 4px 0;
    padding: 0 1.5rem;
    background-color: #DB5378;
    border: none;
    color: white;
    transition: background-color 0.15s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 56px;
    font-size: 1.2rem;
  }

  .search-button:hover {
    background-color: #c44a6a;
  }

  .product-skeleton {
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 20px;
  }

  .skeleton-image {
    background: #f0f0f0;
    height: 200px;
    border-radius: 4px;
    margin-bottom: 15px;
    animation: pulse 1.5s infinite;
  }

  .skeleton-content {
    padding: 10px 0;
  }

  .skeleton-title {
    background: #f0f0f0;
    height: 20px;
    width: 80%;
    margin-bottom: 10px;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
  }

  .skeleton-text {
    background: #f0f0f0;
    height: 15px;
    width: 60%;
    margin-bottom: 10px;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
  }

  .skeleton-price {
    background: #f0f0f0;
    height: 25px;
    width: 40%;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  .box-title {
    margin-bottom: 2rem;
    text-align: center;
  }

  .box-title h1 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 1.5rem;
  }

  .subcategorias {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .subcategorias li a {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    color: #666;
    text-decoration: none;
    border-radius: 25px;
    background-color: #f5f5f5;
    transition: all 0.3s ease;
    font-size: 1rem;
    border: 1px solid transparent;
  }

  .subcategorias li a:hover {
    background-color: #e9e9e9;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .subcategorias li a.active {
    background-color: #DB5378;
    color: white;
    font-weight: 500;
    border-color: #DB5378;
    box-shadow: 0 2px 4px rgba(219, 83, 120, 0.2);
  }

  .no-results-container {
    text-align: center;
    padding: 3rem 1rem;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    margin: 2rem auto;
    max-width: 600px;
  }

  .no-results-icon {
    font-size: 3rem;
    color: #DB5378;
    margin-bottom: 1rem;
  }

  .no-results-container h3 {
    color: #333;
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .no-results-container p {
    color: #666;
    margin-bottom: 1.5rem;
  }

  .suggestions {
    text-align: left;
    max-width: 400px;
    margin: 0 auto;
  }

  .suggestions p {
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  .suggestions ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .suggestions li {
    color: #666;
    padding: 0.5rem 0;
    position: relative;
    padding-left: 1.5rem;
  }

  .suggestions li:before {
    content: "•";
    color: #DB5378;
    position: absolute;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/CategoryPage.vue